import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n0, n2 } from "../../lib/format";
import { Notice } from "../../lib/ui";

/*
 * Replenish stock – port of stockReprenish.php (API: POST /api/replenishments, backend/stock2.py)
 * Adds the quantity to the product's stock and sets its purchase price to the new price.
 */

const BLANK = { product_id: "", quantity_added: "", purchase_price: "", supplier: "" };

export default function Replenish() {
  const api = useApi();
  const [products, setProducts] = useState([]);
  const [f, setF] = useState(BLANK);
  const [notice, setNotice] = useState(null);
  const [busy, setBusy] = useState(false);

  const loadProducts = () => api.get("/api/products/options").then(setProducts).catch((e) => setNotice({ tone: "err", text: e.message }));
  useEffect(() => { loadProducts(); }, [api]); // eslint-disable-line react-hooks/exhaustive-deps
  const chosen = useMemo(() => products.find((p) => String(p.id) === String(f.product_id)), [products, f.product_id]);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setBusy(true); setNotice(null);
    try {
      const r = await api.post("/api/replenishments", f);
      setNotice({ tone: "ok", text: `${r.message} ${chosen?.name}: ${n0(chosen?.quantity)} + ${n0(f.quantity_added)} = ${n0(Number(chosen?.quantity || 0) + Number(f.quantity_added))}` });
      setF(BLANK); loadProducts();
    } catch (err) { setNotice({ tone: "err", text: err.message }); }
    finally { setBusy(false); }
  };

  return (
    <main className="pg" style={{ maxWidth: "46rem" }}>
      <PageHeader slug="stockReprenish" actions={<Link to="/addStockreplenish" className="btn"><i className="fas fa-list" /> Replenishment history</Link>} />
      <Notice notice={notice} onClose={() => setNotice(null)} />
      <div className="panel">
        <form className="form" onSubmit={save} style={{ maxWidth: "none" }}>
          <div className="field wide"><label htmlFor="rp-p">Product<span className="req">*</span></label>
            <select id="rp-p" required value={f.product_id} onChange={(e) => {
              const p = products.find((x) => String(x.id) === e.target.value);
              setF((s) => ({ ...s, product_id: e.target.value, purchase_price: s.purchase_price || (p ? String(p.purchase_price) : "") }));
            }}>
              <option value="" disabled>Select a product</option>
              {products.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
            {chosen && <span className="hint">In stock: {n0(chosen.quantity)} · current purchase price {n2(chosen.purchase_price)}</span>}</div>
          <div className="field"><label htmlFor="rp-q">Quantity added<span className="req">*</span></label><input id="rp-q" type="number" min="1" required value={f.quantity_added} onChange={set("quantity_added")} placeholder="e.g. 100" /></div>
          <div className="field"><label htmlFor="rp-pr">Purchase price<span className="req">*</span></label><input id="rp-pr" type="number" step="0.01" min="0.01" required value={f.purchase_price} onChange={set("purchase_price")} placeholder="e.g. 25.00" /></div>
          <div className="field wide"><label htmlFor="rp-s">Supplier</label><input id="rp-s" value={f.supplier} onChange={set("supplier")} placeholder="e.g. Jembe Suppliers" /></div>
          <div className="form-actions"><button type="submit" className="btn primary" disabled={busy}>{busy ? "Saving…" : "Replenish stock"}</button></div>
        </form>
      </div>
    </main>
  );
}
